var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-top"},[_vm._v("\n  "+_vm._s(_vm.$t('回到頂部'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }